<template>
  <modal :modal-key="'resub_question_via_sms'"
         :class-style="'modal--welcomeback'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_resubscribe_via_sms_do_you_want }}</h1>
      <img :src="getTranslations.project_config_modal_img" alt="">
    </template>
    <template slot="body">
      {{ getTranslations.home_modals_resubscribe_via_sms_by_resubscribing_you_will }}
      <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'home_modals_resubscribe_via_sms_redirecting_to_lp')" target="_blank">{{ getTranslations.home_modals_resubscribe_via_sms_here }}</a>
      <br><br>
      {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal,
      'project_config_resub_resubscribe_questions_via_sms') }}
    </template>
    <template slot="footer">
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  // modal_resubscribe_request_SMS.html
  name: 'resubscribe-question',
  components: {
    Modal,
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeQuestionViaSms.vue